export default {"src":"/_next/static/media/library_white.fbc73f3f.svg","height":20,"width":26,"blurWidth":0,"blurHeight":0};